import React from 'react';
import { Form, Input} from 'antd';
  
const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 24},
    },
};

class FormInputTextArea2 extends React.Component {

    render(){
        const field = this.props.field ? this.props.field : 'meta_description';
        const label = this.props.label ? this.props.label : field;
        const required = this.props.required === undefined ? true : this.props.required;
        const textSize = this.props.textSize ? this.props.textSize : 5;
        return (
        <Form.Item
            {...formItemLayout}
            label={label}
            colon={false}>
            {this.props.getFieldDecorator(field, {
                initialValue: this.props.initialValue,
                rules: [{
                    required: required, message: 'فیلد را پر کنید',
                }],
            })(
                <Input.TextArea rows={textSize}  onChange={(e)=>{this.props.update(e.target.value, field)}}/>
            )}
        </Form.Item>
        );
    }
}

export default FormInputTextArea2;


// WEBPACK FOOTER //
// ./src/containers/Pages/Partials/FormInputTextArea2.js